<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <path
      :fill="iconColor"
      fill-rule="evenodd"
      d="M52.802 69.49c-.097-.08-.458-.223-1.085-.43l-1.518-.456-1.229-.36-1.108-.43c-.499-.192-.868-.367-1.109-.527-.867-.639-1.414-1.15-1.638-1.533a5.235 5.235 0 0 1-.603-2.467c0-1.597.59-2.834 1.771-3.712 1.181-.878 2.8-1.318 4.856-1.318s3.96.464 5.711 1.39v4.143c-.755-.463-1.647-.846-2.675-1.15-1.06-.319-2.056-.479-2.988-.479-1.478 0-2.217.368-2.217 1.102 0 .32.233.575.699.766l.771.264c.177.064.554.176 1.133.335.578.16.972.272 1.18.336 1.607.526 2.876 1.19 3.808 1.988.916.782 1.374 1.9 1.374 3.353 0 1.628-.643 2.938-1.928 3.928-1.27.974-2.924 1.46-4.964 1.46-2.603 0-4.78-.598-6.53-1.796V69.49c.674.623 1.638 1.166 2.89 1.629 1.206.447 2.362.67 3.47.67 1.72 0 2.58-.438 2.58-1.317 0-.35-.217-.678-.651-.982zm-9.953 2.084v3.784H30.415V58.593h4.338v12.981h8.096zm28.359 21.908H16.07c-2.287 0-4.148-1.85-4.148-4.125v-4.77h51.4c2.384 0 4.316-1.918 4.316-4.288V54.29c0-2.37-1.932-4.29-4.315-4.29H11.922v-3.194h2.198v-4h-2.198v-8.533h10.27v5.311h4.025v-5.311h5.677v-4h-5.677V19.167h11.067v4.173h4.025v-4.173h4.344v-4h-4.344v-8.67l12.718-.012V20.43c0 4.073 3.325 7.38 7.426 7.38l13.744-.039.155 61.586c0 2.275-1.858 4.125-4.144 4.125zm-59.3-34.89h5.06l2.989 4.312 3.012-4.311h4.988l-5.494 7.736 6.458 9.03h-5.085l-3.952-5.581-3.928 5.58h-5.012l6.458-9.005-5.494-7.76zm.014-28.32h10.27V19.167h-10.27v11.105zm0-19.63c0-2.268 1.861-4.118 4.148-4.118l6.122-.006v8.649h-10.27v-4.524zm14.295-4.128l11.067-.012v8.665H26.217V6.514zM56.48 0H16.07C10.166 0 5.36 4.78 5.36 10.643V50H4.316C1.932 50 0 51.92 0 54.289v26.01c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77C5.36 95.227 10.166 100 16.07 100h55.138c5.9 0 10.705-4.773 10.705-10.643V25.19L56.48 0z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'icon-xlc',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
